/**
 * Csv Schema of ResponsavelFilial
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {ResponsavelFilial} from '@/model/resource/ResponsavelFilial'

/* TODO: review generated schema */
export class CsvResponsavelFilialSchema extends Schema {
  readonly name = 'CsvResponsavelFilial'

  readonly fieldSet: FieldSet<ResponsavelFilial> = {
    idFilialPk: schema => schema.model.idFilialPk,
    cnpjBase: schema => schema.model.cnpjBase,
  }
}
